import { FC, useContext, useEffect, useState } from "react";
import { Controller, useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import {Link, useNavigate, useSearchParams} from "react-router-dom";

import HubInputField from "../../components/inputType";

import { resetpasswordSchema } from "../../validation/resetPassword";
import useFetch from "../../hooks/useFetch";
import { APIEndpoints } from "../../types/apiTypes";
import { ResetPasswordAPIErrorResponseType, ResetPasswordAPISuccessResponseType } from "./types";
import { ToastContext } from "../../context/toastContext";
import { ToastTypes } from "../../types";
import {PHONE_NUMBER} from "../../constants/contact";
import {paciraLogo} from "../../assets";
import Footer from "../../components/footer";



const HubResetPassword: FC = (): JSX.Element => {
  const [resetToken, setResetToken] = useState<string>('');
  const [searchParams] = useSearchParams();

  const { showToast } = useContext(ToastContext);
  const navigate = useNavigate();
  const { control, handleSubmit } = useForm({
    mode: 'all',
    resolver: yupResolver(resetpasswordSchema),
  });





  const { loading, data, error, removeErrorAndData, mutate } = useFetch<ResetPasswordAPISuccessResponseType>(APIEndpoints.USER_RESET_PASSWORD);

  useEffect(() => {
    const obj = new URLSearchParams(searchParams);
    setResetToken(obj.get('reset_password_token') || '');
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (data) {
      const { message } = data;
      showToast([message], ToastTypes.SUCCESS);
      navigate("/users/sign_in");
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [data]);

  const submitPassword = async (values: { password: string, confirmPassword: string }) => {
    if ((error && error.length > 0) || data) removeErrorAndData();
    mutate({ user: { reset_password_token: resetToken, ...values } });
  };

  return (
      <div className="container-fluid login-sec d-flex flex-fill flex-column justify-content-between overflow-auto">
          <div className="container d-flex flex-fill flex-column align-items-center pt-4 pb-4 ps-4 pe-4">
              <div className="row justify-content-center align-items-center flex-fill mb-3">
                  <div className="col-12 col-md-7">
                      <h1 className="login-text">A Successful Surgery and Recovery Begins with a Pain Management Plan.</h1>
                  </div>
                  <div className="col-12 col-md-1"></div>
                  <div className="col-12 col-md-4">
                      <form className="card shadow-lg" onSubmit={handleSubmit(submitPassword)}>
                          <div className="card-header">
                              <h3 className="m-0">Reset Password</h3>
                              <small className="m-0">Please sign in with your credentials</small>
                          </div>

                          <div className="card-body">
                              <div className="mb-4">
                                  <Controller
                                      name="password"
                                      control={control}
                                      defaultValue=''
                                      render={({ field, fieldState: { error } }) => (
                                          <HubInputField
                                              inputId="password"
                                              isRowBased={false}
                                              isRequired={true}
                                              field={field}
                                              error={error}
                                              inputType="password"
                                              inputPlaceholder="New Password"
                                          />
                                      )}
                                  />
                              </div>
                              <Controller
                                  name="confirmPassword"
                                  control={control}
                                  defaultValue=''
                                  render={({ field, fieldState: { error } }) => (
                                      <HubInputField
                                          inputId="confirmPassword"
                                          isRowBased={false}
                                          isRequired={true}
                                          field={field}
                                          error={error}
                                          inputType="password"
                                          inputPlaceholder="Confirm Password"
                                      />
                                  )}
                              />
                              <p className="small m-0">By clicking sign in below, you agree to our&nbsp;
                                  <a href="https://www.exparelpro.com/terms-of-use" target="_blank" rel="noreferrer">
                                      Terms of Use
                                  </a>
                              </p>
                          </div>

                          <div className="card-footer d-flex align-items-center justify-content-between">
                              <button disabled={loading} className="btn btn-primary" type="submit">
                                  {loading ? (
                                      <div className="spinner-border text-light col-3" role="status">
                                          <span className="sr-only"></span>
                                      </div>
                                  ) : null}
                                  Reset Password
                              </button>
                          </div>
                      </form>
                  </div>
              </div>
              <div>
                  <p className="mb-3 text-white" style={{fontSize: '1rem'}}>
                      For more information, please visit&nbsp;
                      <a target="_blank" className="text-secondary" href="https://www.exparelpro.com"
                         rel="noreferrer">www.exparelpro.com</a>&nbsp;
                      or call {PHONE_NUMBER}. You are encouraged to report negative side effects of prescription drugs to
                      FDA; visit&nbsp;
                      <a target="_blank" className="text-secondary" href="http://www.fda.gov/medwatch" rel="noreferrer">
                          MedWatch: FDA Safety Information & Adverse Event Reporting Program
                      </a>&nbsp;
                      or call 1-800-FDA-1088.
                  </p>
                  <div className="row align-items-center">
                      <div className="col-12 col-sm-2">
                          <img className="img-fluid" width={170} src={paciraLogo} alt="Products Logos"/>
                      </div>
                      <p className="col text-white m-0" style={{fontSize:'1rem'}}>
                          ©2025 Pacira Pharmaceuticals, Inc., a wholly owned subsidiary of Pacira BioSciences, Inc. EXPAREL is a
                          registered trademark of Pacira Therapeutics, Inc. PP-EX-US-9728 July 2025
                      </p>
                  </div>
              </div>
          </div>
          <Footer/>
      </div>
  );
};

export default HubResetPassword;
